<script setup>
  import { ref, computed, defineAsyncComponent } from 'vue'
  import { useSheetContentComponent } from "@/composables/useSheetContentComponent";
  import { useSheetController } from "@/composables/useSheetsController";
  import { useMediaQuery } from '@/composables/useMediaQuery';

  import SheetBase from '@/components/SheetBase.vue'
  import LoaderCircle from '@/components/LoaderCircle.vue';

  const props = defineProps({
    position: {
      type: String,
      default: 'primary'
    }
  });

  
  const type = 'info';
  const isDesktop = useMediaQuery('(min-width: 840px)');

  useSheetController.registerSheet(type, props.position);

  let content = ref();

  const components = {
      SheetContentAdvisories: defineAsyncComponent(() => import('@/components/SheetContentAdvisories.vue')),
      SheetContentMarineForecast: defineAsyncComponent(() => import('@/components/SheetContentMarineForecast.vue')),
      SheetContentStormForecast: defineAsyncComponent(() => import('@/components/SheetContentStormForecast.vue')),
      SheetContentDsatOperatingConditions: defineAsyncComponent(() => import('@/components/SheetContentDsatOperatingConditions.vue')),
    };  

  const isSheetOpen = computed(() => {
    return useSheetController.sheets[type].open;
  })    

  const startingHeightState = computed(() => isDesktop.value ? 'maximized' : 'mid');

  window.$EventBus.addEventListener('marine-forecast-clicked', e => {
    useSheetController.toggleSheet(type, 'marine-forecast', true);

    content.value = e.detail.forecasts;
  })

  window.$EventBus.addEventListener('advisory-clicked', e => {
    useSheetController.toggleSheet(type, 'advisories', true);

    content.value = e.detail.advisory;
  })
</script>

<template>
    <SheetBase 
      :type="type" 
      :starting-height-state="startingHeightState" 
      :position="props.position"
      v-slot="{ transtionName }"
    >
    <Suspense timeout="600">
      <component
        v-if="isSheetOpen"
        :is="useSheetContentComponent(type, components)" 
        :content="content" 
        :type="type"
        :transtionName="transtionName"
      />

      <template #fallback>
        <LoaderCircle />
      </template>      
    </Suspense>
  </SheetBase>
</template>